// ShareCertificateDashboard.jsx
import React, { useState } from "react";
import "./Share.css";

const initialData = [
  { certificateNumber: "SC001", shareholderName: "Navin Kumar", shareType: "Equity", shares: 100, issueDate: "2025-01-01", status: "Active" },
  { certificateNumber: "SC002", shareholderName: "Ramesh Kumar", shareType: "Preference", shares: 50, issueDate: "2025-02-15", status: "Transferred" },
  { certificateNumber: "SC003", shareholderName: "Sita Devi", shareType: "Equity", shares: 200, issueDate: "2025-03-10", status: "Active" }
];

const ShareCertificateDashboard = () => {
  const [data, setData] = useState(initialData);
  const [filters, setFilters] = useState({});
  const [selectedCert, setSelectedCert] = useState(null);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
  };

  const filteredData = data.filter((row) => {
    return (
      (!filters.certificateNumber || row.certificateNumber.includes(filters.certificateNumber)) &&
      (!filters.shareholderName || row.shareholderName.toLowerCase().includes(filters.shareholderName?.toLowerCase())) &&
      (!filters.shareType || row.shareType === filters.shareType) &&
      (!filters.status || row.status === filters.status) &&
      (!filters.fromDate || new Date(row.issueDate) >= new Date(filters.fromDate)) &&
      (!filters.toDate || new Date(row.issueDate) <= new Date(filters.toDate))
    );
  });

  const resetFilters = () => setFilters({});

  return (
    <div className="sc-dashboard">
      {/* Header */}
      <header className="sc-header">
        <div className="sc-logo">Bank Logo</div>
        
      </header>

      {/* Main Content */}
      <div className="sc-main">
        {/* Filter */}
        <form className="sc-filter" onSubmit={handleFilterSubmit}>
          <input type="text" name="certificateNumber" placeholder="Certificate No" value={filters.certificateNumber || ""} onChange={handleFilterChange} />
          <input type="text" name="shareholderName" placeholder="Shareholder Name" value={filters.shareholderName || ""} onChange={handleFilterChange} />
          <select name="shareType" value={filters.shareType || ""} onChange={handleFilterChange}>
            <option value="">Share Type</option>
            <option value="Equity">Equity</option>
            <option value="Preference">Preference</option>
          </select>
          <select name="status" value={filters.status || ""} onChange={handleFilterChange}>
            <option value="">Status</option>
            <option value="Active">Active</option>
            <option value="Transferred">Transferred</option>
            <option value="Cancelled">Cancelled</option>
          </select>
          <input type="date" name="fromDate" value={filters.fromDate || ""} onChange={handleFilterChange} />
          <input type="date" name="toDate" value={filters.toDate || ""} onChange={handleFilterChange} />
          <button type="submit">Search</button>
          <button type="button" onClick={resetFilters}>Reset</button>
        </form>

        {/* Table */}
        <div className="sc-table-container">
          <table>
            <thead>
              <tr>
                <th>Certificate No</th>
                <th>Shareholder Name</th>
                <th>Share Type</th>
                <th>Shares</th>
                <th>Issue Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr><td colSpan="7">No records found</td></tr>
              ) : (
                filteredData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.certificateNumber}</td>
                    <td>{row.shareholderName}</td>
                    <td>{row.shareType}</td>
                    <td>{row.shares}</td>
                    <td>{row.issueDate}</td>
                    <td>{row.status}</td>
                    <td>
                      <button onClick={() => setSelectedCert(row)}>View</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {selectedCert && (
        <div className="sc-modal-overlay">
          <div className="sc-modal-box">
            <h2>Share Certificate Details</h2>
            <p><strong>Certificate No:</strong> {selectedCert.certificateNumber}</p>
            <p><strong>Shareholder Name:</strong> {selectedCert.shareholderName}</p>
            <p><strong>Share Type:</strong> {selectedCert.shareType}</p>
            <p><strong>Shares:</strong> {selectedCert.shares}</p>
            <p><strong>Issue Date:</strong> {selectedCert.issueDate}</p>
            <p><strong>Status:</strong> {selectedCert.status}</p>
            <div className="sc-modal-actions">
              <button onClick={() => setSelectedCert(null)}>Close</button>
              <button onClick={() => window.print()}>Print / PDF</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareCertificateDashboard;
